import React, { createContext, useContext, ReactNode } from "react";

import useAuth from "./hooks/useAuth";
import { checkIsPlus, checkAlunoABA, checkShowPos, checkShowCurriculo } from "../../constants/userGroups";

interface UserContextState {
	authenticated: boolean;
	tenantData: any;
	userData: any;
	loading: boolean;
	handleLogin(email: string, password: string): Promise<object>;
	handleLogout(): void;
	isPlus(): boolean;
	alunoABA(): boolean;
	showPos(): boolean;
	showCurriculo(): boolean;
}

const UserContext = createContext({} as UserContextState);

interface ProviderProps {
	children: ReactNode;
}

const AuthProvider: React.FC<ProviderProps> = ({ children }) => {
	const { authenticated, tenantData, userData, loading, handleLogin, handleLogout } = useAuth();

	const isPlus = () => checkIsPlus(userData.grupos);

	const alunoABA = () => checkAlunoABA(userData.grupos);

	const showPos = () => checkShowPos(userData.grupos);

	const showCurriculo = () => checkShowCurriculo(userData.grupos);

	return (
		<UserContext.Provider
			value={{
				userData,
				tenantData,
				loading,
				authenticated,
				handleLogin,
				handleLogout,
				isPlus,
				showPos,
				alunoABA,
				showCurriculo,
			}}>
			{children}
		</UserContext.Provider>
	);
};

export const useUserContext = () => useContext(UserContext);

export { AuthProvider };
